module.exports = __webpack_public_path__ + "img/icon-result2.png";